import React from "react";
import { useState } from "react";
import Tabwishkey from "./Tabwishkey";

function Tabs({ products }) {
  const [toggleState, setToggleState] = useState("whiskey");

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <div className="Ourproduct">
      <div className="container">
        <div className="row">
          <div className="col-md-7">
            <div className="Ophead">
              <h1>Our Products</h1>
              <p>
                The best selection of your choice|{" "}
                <a href=" ">
                  <span>
                    View all <i class="fa-solid fa-chevron-right"></i>
                  </span>
                </a>
              </p>
            </div>
          </div>
          <div className="col-md-5">
            <div className="bloc-tabs">
              <button
                className={
                  toggleState === "whiskey" ? "tabs active-tabs" : "tabs"
                }
                onClick={() => toggleTab("whiskey")}
              >
                Wishkey
              </button>
              <button
                className={toggleState === "beer" ? "tabs active-tabs" : "tabs"}
                onClick={() => toggleTab("beer")}
              >
                Beer
              </button>
              <button
                className={toggleState === "wine" ? "tabs active-tabs" : "tabs"}
                onClick={() => toggleTab("wine")}
              >
                Wine
              </button>
              <button
                className={toggleState === "rum" ? "tabs active-tabs" : "tabs"}
                onClick={() => toggleTab("rum")}
              >
                Rum
              </button>
              <button
                className={
                  toggleState === "snacks" ? "tabs active-tabs" : "tabs"
                }
                onClick={() => toggleTab("snacks")}
              >
                Soft Drinks & Snacks
              </button>{" "}
            </div>
          </div>
          <div className="content-tabs">
            <Tabwishkey toggleState={toggleState} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Tabs;
